var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "yto-box", staticStyle: { "padding-bottom": "10px" } },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "templateForm",
              attrs: { inline: true, model: _vm.form, "label-width": "70px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模板名称", prop: "templateName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "260px" },
                    attrs: { placeholder: "请输入模板名称", clearable: "" },
                    model: {
                      value: _vm.form.templateName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "templateName", $$v)
                      },
                      expression: "form.templateName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "快递公司", prop: "cpCode" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.form.cpCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cpCode", $$v)
                        },
                        expression: "form.cpCode",
                      },
                    },
                    _vm._l(_vm.companyCodeList, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.name, value: item.code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "btn-r", attrs: { label: "" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-search", type: "primary" },
                      on: { click: _vm.queryTemplateList },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    { staticClass: "normal-btn", on: { click: _vm.resetForm } },
                    [
                      _c("i", {
                        staticClass: "el-icon-refresh-left y-fc-4C84FF",
                      }),
                      _vm._v("重置"),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "yto-table y-pd-20" },
        [
          _c(
            "div",
            { staticClass: "y-mb-20" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-circle-plus-outline",
                  },
                  on: {
                    click: function ($event) {
                      _vm.isShowTpl = true
                    },
                  },
                },
                [_vm._v("添加电子面单模板")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            { attrs: { data: _vm.tableData } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "模板样式",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "y-p-r pre-box" },
                          [
                            _vm.defaultTemplateType.includes(
                              scope.row.baseTempId
                            )
                              ? _c("el-image", {
                                  staticStyle: {
                                    width: "auto",
                                    height: "70px",
                                  },
                                  attrs: {
                                    src: require(`@/assets/images/${scope.row.baseTempId}.png`),
                                    "preview-src-list": [
                                      require(`@/assets/images/${scope.row.baseTempId}.png`),
                                    ],
                                  },
                                })
                              : _c("el-image", {
                                  staticStyle: {
                                    width: "auto",
                                    height: "70px",
                                  },
                                  attrs: {
                                    src: require("@/assets/images/88880001.png"),
                                    "preview-src-list": [
                                      require("@/assets/images/88880001.png"),
                                    ],
                                  },
                                }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "y-fw-700" }, [
                          _vm._v(_vm._s(scope.row.templateType)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "模板名称", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.tempName))]),
                        _c("div", [
                          _vm._v("尺寸：" + _vm._s(scope.row.curTemplatSize)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "电子面单信息", "min-width": "230" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.printAccount != "KTHJ999999" &&
                        scope.row.waybillCode != "THJ"
                          ? _c("div", [
                              scope.row.waybillCode === "YTO" ||
                              scope.row.waybillCode === "YTO_ZD"
                                ? _c("div", { staticClass: "y-f y-f-jb" }, [
                                    scope.row.printAccount
                                      ? _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              "账号：" +
                                                _vm._s(scope.row.printAccount)
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              "网点名称：" +
                                                _vm._s(
                                                  scope.row.printAccountName
                                                )
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "y-w-115 y-fc-4C84FF y-c-p",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showOriginDialog(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                              }),
                                              _vm._v("修改电子面单账号"),
                                            ]
                                          ),
                                        ])
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "y-w-115 y-fc-4C84FF y-c-p",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showOriginDialog(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-circle-plus-outline",
                                            }),
                                            _vm._v("添加电子面单账号"),
                                          ]
                                        ),
                                  ])
                                : _c("div", { staticClass: "y-f y-f-jb" }, [
                                    scope.row.addressInfoList ||
                                    scope.row.printAccount
                                      ? _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              "账号：" +
                                                _vm._s(scope.row.mallName || "")
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              "网点名称：" +
                                                _vm._s(
                                                  scope.row.printAccountName ||
                                                    ""
                                                )
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              "网点发货地址：" +
                                                _vm._s(
                                                  scope.row.addressInfo || ""
                                                )
                                            ),
                                          ]),
                                          _vm.bindDataList[scope.row.id] &&
                                          scope.row.waybillCode != "DEWU"
                                            ? _c("div", [
                                                _vm._v(" 余额： "),
                                                _vm.bindDataList[scope.row.id]
                                                  .isRefreshAvailable &&
                                                !_vm.cpCodeList.includes(
                                                  scope.row.wpCode
                                                )
                                                  ? _c("span", [
                                                      _vm.bindDataList[
                                                        scope.row.id
                                                      ].apiLoading
                                                        ? _c("i", {
                                                            staticClass:
                                                              "el-icon-loading",
                                                          })
                                                        : _vm.bindDataList[
                                                            scope.row.id
                                                          ].isUnAuthed
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "y-fc-F56C6C",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "账号失效，请重新绑定"
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "y-fc-4C84FF y-ml-5 y-c-p",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.getRemainingSum(
                                                                      scope.row,
                                                                      scope.row
                                                                        .id,
                                                                      true
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("点击重试")]
                                                          ),
                                                    ])
                                                  : !_vm.cpCodeList.includes(
                                                      scope.row.wpCode
                                                    )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        class: {
                                                          "y-fc-F32F52":
                                                            _vm.bindDataList[
                                                              scope.row.id
                                                            ].remainingSum <=
                                                            100,
                                                          "y-fc-3bb950":
                                                            _vm.bindDataList[
                                                              scope.row.id
                                                            ].remainingSum >
                                                            100,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.bindDataList[
                                                                scope.row.id
                                                              ].remainingSum
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [_vm._v("-")]),
                                              ])
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "y-w-115 y-fc-4C84FF y-c-p",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showOriginDialog(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-edit",
                                              }),
                                              _vm._v("修改电子面单账号"),
                                            ]
                                          ),
                                        ])
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "y-w-115 y-fc-4C84FF y-c-p",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showOriginDialog(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-circle-plus-outline",
                                            }),
                                            _vm._v("添加电子面单账号"),
                                          ]
                                        ),
                                  ]),
                            ])
                          : scope.row.waybillCode != "THJ"
                          ? _c("div", [
                              _c("div", [
                                _vm._v(
                                  "账号：" + _vm._s(scope.row.printAccount)
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "180" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm.bindDataList &&
                            _vm.bindDataList[scope.row.id] &&
                            scope.row.printAccount != "KTHJ999999" &&
                            scope.row.waybillCode != "THJ"
                            ? [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.senderListMap[
                                        _vm.bindDataList[scope.row.id]
                                          .sendAddressId
                                      ]
                                    ),
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "y-w-115 y-fc-4C84FF y-c-p",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSetDefaultAddress(
                                          scope.row,
                                          scope.row.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-edit" }),
                                    _vm._v("设置默认发货地址"),
                                  ]
                                ),
                              ]
                            : undefined
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _vm._v(" 默认发货地址 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "light", placement: "top-start" },
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c("span", [
                                _vm._v(
                                  "为模板设置默认发货地址时，该模板默认发货地址即为此处设置的发货地址，而不是系统发货地址中设置的默认地址"
                                ),
                              ]),
                            ]
                          ),
                          _c("i", {
                            staticClass: "el-icon-question y-fc-4C84FF y-c-p",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c("el-table-column", {
                attrs: { label: "打印机", "min-width": "140" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return _vm.bindDataList &&
                          _vm.bindDataList[scope.row.id] &&
                          scope.row.printAccount != "KTHJ999999"
                          ? [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    size: "mini",
                                    loading:
                                      _vm.bindDataList[scope.row.id]
                                        .printerLoading,
                                    placeholder: "请选择打印机",
                                  },
                                  on: {
                                    focus: function ($event) {
                                      return _vm.handleFocus(
                                        scope.row,
                                        scope.row.id
                                      )
                                    },
                                    change: (val) =>
                                      _vm.handleChangePrint(val, scope.row),
                                  },
                                  model: {
                                    value:
                                      _vm.bindDataList[scope.row.id]
                                        .printerName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.bindDataList[scope.row.id],
                                        "printerName",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "bindDataList[scope.row.id].printerName",
                                  },
                                },
                                _vm._l(
                                  _vm.bindDataList[scope.row.id].printerList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.name,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "150" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return scope.row.printAccount != "KTHJ999999" &&
                            scope.row.waybillCode != "THJ"
                            ? [
                                scope.row.mallEntityList
                                  ? _c(
                                      "div",
                                      { staticClass: "shoplist" },
                                      _vm._l(
                                        scope.row.mallEntityList,
                                        function (item) {
                                          return _c(
                                            "span",
                                            { key: item.mallId },
                                            [
                                              _vm.PLATFORMICONMAP[
                                                item.paltformCode
                                              ]
                                                ? _c("svg-icon", {
                                                    staticClass: "icon",
                                                    attrs: {
                                                      "icon-class":
                                                        _vm.PLATFORMICONMAP[
                                                          item.paltformCode
                                                        ],
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(
                                                _vm._s(item.mallName) + " "
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                                scope.row.mallEntityList &&
                                scope.row.mallEntityList.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "y-w-115 y-pl-5 y-fc-4C84FF y-c-p",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAddShopSetting(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-edit",
                                        }),
                                        _vm._v("修改店铺默认模板"),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "y-w-115 y-pl-5 y-fc-4C84FF y-c-p",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAddShopSetting(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-circle-plus-outline",
                                        }),
                                        _vm._v("添加店铺默认模板"),
                                      ]
                                    ),
                              ]
                            : undefined
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _vm._v(" 店铺默认模板 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "light", placement: "top-start" },
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c("span", [
                                _vm._v(
                                  "为店铺设置默认模板，当在运单打印模块切换到该店铺时，电子面单模板将自动切换。"
                                ),
                              ]),
                            ]
                          ),
                          _c("i", {
                            staticClass: "el-icon-question y-fc-4C84FF y-c-p",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "y-f y-f-fc y-f-as" },
                          [
                            _c(
                              "el-link",
                              {
                                staticClass: "y-fs-12",
                                attrs: { underline: false, type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.customTemplate(scope.row)
                                  },
                                },
                              },
                              [_vm._v("自定义模板")]
                            ),
                            _c(
                              "el-link",
                              {
                                staticClass: "y-fs-12",
                                attrs: { underline: false, type: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteTemplate(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "fixed-paginton-footer box-shadow-wrapper" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.page.pageNo,
                  "page-sizes": [10, 50, 100],
                  "page-size": _vm.page.limit,
                  layout: "total, sizes, prev, pager, next",
                  total: _vm.page.total,
                },
                on: {
                  "size-change": _vm.limitChange,
                  "current-change": _vm.pageChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.page, "pageNo", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.page, "pageNo", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                center: "",
                title: _vm.printerTipTitle,
                visible: _vm.visible,
                "close-on-press-escape": false,
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.visible = $event
                },
              },
            },
            [
              _c(
                "el-alert",
                {
                  attrs: { type: "warning", "show-icon": "", closable: false },
                },
                [
                  _vm.curTplWaybillCode === "PDD"
                    ? [
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("请先启动拼多多打印组件后重试。"),
                        ]),
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("如您未安装，请点击"),
                          _c(
                            "a",
                            {
                              staticClass: "systemColor",
                              attrs: {
                                href: "https://meta.pinduoduo.com/api/one/app/v1/lateststable?appId=com.xunmeng.pddprint&platform=windows&subType=main",
                              },
                            },
                            [_vm._v("下载安装")]
                          ),
                          _vm._v("，安装成功后，启动组件重新获取打印机信息"),
                        ]),
                      ]
                    : _vm.curTplWaybillCode === "LUBAN"
                    ? [
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("请先启动抖音打印组件后重试。"),
                        ]),
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("如您未安装，请点击"),
                          _c(
                            "a",
                            {
                              staticClass: "systemColor",
                              attrs: {
                                href: "https://logistics.douyinec.com/davinci/CloudPrintClient",
                              },
                            },
                            [_vm._v("下载安装")]
                          ),
                          _vm._v("，安装成功后，启动组件重新获取打印机信息"),
                        ]),
                      ]
                    : _vm.curTplWaybillCode === "KS"
                    ? [
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("请先启动快手打印组件后重试。"),
                        ]),
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("如您未安装，请点击"),
                          _c(
                            "a",
                            {
                              staticClass: "systemColor",
                              attrs: {
                                href: "https://cloudprint.kwaixiaodian.com/rest/pc/scm/ebill/print/installer/download",
                              },
                            },
                            [_vm._v("下载安装")]
                          ),
                          _vm._v("，安装成功后，启动组件重新获取打印机信息"),
                        ]),
                      ]
                    : _vm.curTplWaybillCode === "JD"
                    ? [
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("请先启动京东打印组件后重试。"),
                        ]),
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("如您未安装，请点击"),
                          _c(
                            "a",
                            {
                              staticClass: "systemColor",
                              attrs: {
                                href: "https://prod-oms-app-cprt.jdwl.com/OpenCloudPrint/setup.exe",
                              },
                            },
                            [_vm._v("下载安装")]
                          ),
                          _vm._v("，安装成功后，启动组件重新获取打印机信息"),
                        ]),
                      ]
                    : _vm.curTplWaybillCode === "WXSPH"
                    ? [
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("请先启动腾讯打印组件后重试。"),
                        ]),
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("如您未安装，请点击"),
                          _c(
                            "a",
                            {
                              staticClass: "systemColor",
                              attrs: {
                                href: "https://res.wx.qq.com/shop/print/ChannelsShopPrintClient-setup.exe",
                              },
                            },
                            [_vm._v("下载安装")]
                          ),
                          _vm._v("，安装成功后，启动组件重新获取打印机信息"),
                        ]),
                      ]
                    : _vm.curTplWaybillCode === "WXGYS"
                    ? [
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("请先启动腾讯打印组件后重试。"),
                        ]),
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("如您未安装，请点击"),
                          _c(
                            "a",
                            {
                              staticClass: "systemColor",
                              attrs: {
                                href: "https://res.wx.qq.com/shop/print/ChannelsShopPrintClient-setup.exe",
                              },
                            },
                            [_vm._v("下载安装")]
                          ),
                          _vm._v("，安装成功后，启动组件重新获取打印机信息"),
                        ]),
                      ]
                    : _vm.curTplWaybillCode === "XIAOHS"
                    ? [
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("请先启动小红书新打印组件后重试。"),
                        ]),
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("如您未安装，请点击"),
                          _c(
                            "a",
                            {
                              staticClass: "systemColor",
                              attrs: {
                                href: "https://xhswaybill-printer-1251524319.cos.ap-shanghai.myqcloud.com/XHSPrintClient/prod/windows/xhs-electron-printer_x64-setup.exe",
                              },
                            },
                            [_vm._v("下载安装")]
                          ),
                          _vm._v("，安装成功后，启动组件重新获取打印机信息"),
                        ]),
                      ]
                    : _vm.curTplWaybillCode === "DEWU"
                    ? [
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("请先启动得物新打印组件后重试。"),
                        ]),
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("如您未安装，请点击"),
                          _c(
                            "a",
                            {
                              staticClass: "systemColor",
                              attrs: {
                                href: "https://h5static.dewu.com/print-app/client/win/%E5%BE%97%E7%89%A9%E6%89%93%E5%8D%B0%20Setup.exe",
                              },
                            },
                            [_vm._v("下载安装")]
                          ),
                          _vm._v("，安装成功后，启动组件重新获取打印机信息"),
                        ]),
                      ]
                    : [
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("请先启动菜鸟打印组件后重试。"),
                        ]),
                        _c("p", { staticClass: "y-fs-14" }, [
                          _vm._v("如您未安装，请点击"),
                          _c(
                            "a",
                            {
                              staticClass: "systemColor",
                              attrs: {
                                href: "https://cainiao-oss-sh-read.oss-cn-shanghai.aliyuncs.com/waybill-print/cainiao-x-print/prod/win/cainiao-x-print-win-86.exe?spm=a219a.7386653.0.0.214c669aAlb85m&file=cainiao-x-print-win-86.exe",
                              },
                            },
                            [_vm._v("下载安装")]
                          ),
                          _vm._v("，安装成功后，启动组件重新获取打印机信息"),
                        ]),
                      ],
                ],
                2
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "y-w-100",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.visible = false
                        },
                      },
                    },
                    [_vm._v("知道了")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                "custom-class": "add-address-dialog",
                center: "",
                visible: _vm.addAddressDialog,
                "show-close": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.addAddressDialog = $event
                },
              },
            },
            [
              _c("div", { staticClass: "y-fl-32" }, [
                _vm._v(
                  "如您已成功创建发货人地址，请点击确定按钮后，再次点击选择发货地址下拉项进行选择。"
                ),
              ]),
              _c("div", { staticClass: "y-fl-32" }, [
                _vm._v("如您想进行其他操作，请点击取消按钮。"),
              ]),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "y-w-100",
                      on: {
                        click: function ($event) {
                          _vm.addAddressDialog = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "y-w-100",
                      attrs: { type: "primary" },
                      on: { click: _vm.refresh },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm.isShowOrigin
        ? _c("set-default-template-origin", {
            attrs: {
              isShow: _vm.isShowOrigin,
              pageType: "DYALL",
              waybillOrigin: _vm.waybillOrigin,
            },
            on: { closeOriginForm: _vm.closeOriginForm },
          })
        : _vm._e(),
      _vm.isShowTpl
        ? _c("add-face-tpl", {
            attrs: {
              tplList: _vm.tableData,
              visible: _vm.isShowTpl,
              "close-by-confirm": _vm.getUserPrintTempList,
            },
            on: {
              "update:visible": function ($event) {
                _vm.isShowTpl = $event
              },
              showShopSetting: _vm.showShopSettingFromFaceTpl,
            },
          })
        : _vm._e(),
      _vm.isShowShopSetting
        ? _c("addShopDefaultTpl", {
            attrs: {
              curRowInfo: _vm.curRowInfo,
              visible: _vm.isShowShopSetting,
              "close-by-confirm": _vm.getUserPrintTempList,
            },
            on: {
              "update:visible": function ($event) {
                _vm.isShowShopSetting = $event
              },
            },
          })
        : _vm._e(),
      _c("selectAddressDialog", {
        attrs: { hideAddBtn: true, show: _vm.showDialog, type: "sender" },
        on: {
          handleSelected: _vm.handleSelected,
          "update:show": function ($event) {
            _vm.showDialog = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }